// extracted by mini-css-extract-plugin
module.exports = {"block":"Article_block__RIrbi","card":"Article_card__iU_i2","category":"Article_category__sCRRa","title":"Article_title__Fy7Pp","date":"Article_date__tq5g_"};